import api from '@utils/api';

/**
 * Obtiene los datos del dashboard de consumo e ingresos.
 * @param {Object} params  { start_date?: 'YYYY-MM-DD', end_date?: 'YYYY-MM-DD' }
 */
export const getDashboardData = async (params = {}) => {
  const response = await api.get('/analytics/dashboard', { params });
  return response.data;
};
